import React from 'react'

const Affiliate = () => {
  return <h2>Affiliate</h2>
}

export default Affiliate
